import React, { useState, useEffect, useRef } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import Letter_actions from "./Letter_actions";
import {
  setFormExportsUsersRetrieveAction,
  setFormReportsUpdatedAction,
} from "../../../Redux/Slice";
import Swal from "sweetalert2";
import ApprovedIcon from "../../../Assets/AppComponent/icons/Group 359.svg";
import PendingIcon from "../../../Assets/AppComponent/icons/Group 145.svg";
import RejectedIcon  from "../../../Assets/AppComponent/icons/reject_icons.svg";

const RequestedPopup = (props) => {
  const { show, setshow, id, date_of_joining, user_details } = props;
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
const [activeTab, setActiveTab] = useState("ALL");
const tabs = [
  { key: "ALL", label: "All" },
  { key: "PENDING", label: "Pending" },
  { key: "APPROVED", label: "Approved" },
  { key: "REJECTED", label: "Rejected" },
];
const [filteredExports , setFilteredExports] = useState(null)
  

  useEffect(() => {
    if (id) {
      const payload = {
        params: {
          user_id: id,
          is_form_requested: true,
        },
      };
      dispatch(setFormExportsUsersRetrieveAction(payload));
    }
  }, []);
  console.log(state?.Form_ExportsUsers_RetrieveCall_actions?.Form_ExportsUsers ,"?.Form_ExportsUsers_RetrieveCall_actions?.Form_ExportsUsers");


useEffect(() => {
  const source =
    state?.Form_ExportsUsers_RetrieveCall_actions
      ?.Form_ExportsUsers;

  if (!Array.isArray(source)) {
    setFilteredExports([]);
    return;
  }

  let result = [];

  switch (activeTab) {
    case "APPROVED":
      result = source.filter(
        (item) => item.is_request_approved === true
      );
      break;

    case "REJECTED":
      result = source.filter(
        (item) => item.is_request_rejected === true
      );
      break;

    case "PENDING":
      result = source.filter(
        (item) =>
          item.is_request_approved === false &&
          item.is_request_rejected === false
      );
      break;

    case "ALL":
    default:
      result = source;
  }

  console.log("TAB:", activeTab, "COUNT:", result.length ,result);

  setFilteredExports(result);
}, [
  activeTab,
  state?.Form_ExportsUsers_RetrieveCall_actions
    ?.Form_ExportsUsers,
]);




  const handleClose = () => {
    setshow(false);
  };


  const FORM_CONFIG = {
    //1
    appointment_letter: {
      title: "Appointment Letter",
      inputs: [
        {
          id: "end_date",
          label: "End Date (optional)",
          type: "date",
          optional: true,
        },
      ],
      buildPayload: (values, user_id) => ({
        user_id,
        ...(values.end_date && { end_date: values.end_date }),
      }),
    },
    //2
    annual_increment: {
      title: "Annual Increment",
      inputs: [{ id: "revised_salary_date", label: "Revised Salary Date", type: "date" }],
      buildPayload: (v, user_id) => ({
        user_id,
        revised_salary_date: v.revised_salary_date,
      }),
    },
    //3
    mw_revision: {
      title: "MW Salary Revision",
      inputs: [
        {
          id: "mw_revised_salary_date",
          label: "Revised Salary Date",
          type: "date",
        },
      ],
      buildPayload: (v, user_id) => ({
        user_id,
        mw_revised_salary_date: v.mw_revised_salary_date,
      }),
    },

    //4
    letter_change_salary_structure: {
      title: "Change Salary Structure",
      inputs: [
        {
          id: "structure_change_date",
          label: "Structure Change Date",
          type: "date",
        },
      ],
      buildPayload: (v, user_id) => ({
        user_id,
        letter_change_salary_structure_revised_date: v.structure_change_date,
      }),
    },

    //5
    transfer_letter: {
      title: "Transfer Letter",
      inputs: [
        { id: "transfer_date", label: "Transfer Start Date", type: "date" },
      ],
      buildPayload: (v, user_id) => ({
        user_id,
        transfer_start_date: v.transfer_date,
      }),
    },
    //6
    relieving_letter: {
      title: "Relieving Letter",
      inputs: [
        { id: "from_date", label: "From Date", type: "date" },
        { id: "to_date", label: "To Date", type: "date" },
      ],
      validate: (v) =>
        new Date(v.to_date) >= new Date(v.from_date) ||
        "To Date must be after From Date",
      buildPayload: (v, user_id) => ({
        user_id,
        first_date: v.from_date,
        last_date: v.to_date,
      }),
    },
    //7
    experience_letter: {
      title: "Experience Letter",
      inputs: [
        { id: "from_date", label: "From Date", type: "date" },
        { id: "to_date", label: "To Date", type: "date" },
      ],
      validate: (v) =>
        new Date(v.to_date) >= new Date(v.from_date) ||
        "To Date must be after From Date",
      buildPayload: (v, user_id) => ({
        user_id,
        first_date: v.from_date,
        last_date: v.to_date,
      }),
    },
    //8
    absconding: {
      title: "Show Cause – Absconding",
      inputs: [{ id: "reason", label: "Reason", type: "textarea" }],
      buildPayload: (v, user_id) => ({
        user_id,
        showcause_type: "absconding",
        reason: v.reason,
      }),
    },
    //9
    poor_performace: {
      title: "Warning – Poor Performance",
      inputs: [],
      buildPayload: (_, user_id) => ({
        user_id,
        warning_type: "poor_performace",
      }),
    },
    //10
    contract_renewal: {
      title: "Contract Renewal",
      inputs: [
        {
          id: "contract_start_date",
          label: "Contract Start Date",
          type: "date",
        },
        {
          id: "contract_end_date",
          label: "Contract End Date",
          type: "date",
        },
      ],
      validate: (v) =>
        new Date(v.contract_end_date) >= new Date(v.contract_start_date) ||
        "Contract End Date must be after Start Date",
      buildPayload: (v, user_id) => ({
        user_id,
        contract_extended_start_date: v.contract_start_date,
        contract_extended_end_date: v.contract_end_date,
      }),
    },
    //11
    pip: {
      title: "Warning – PIP",
      inputs: [],
      buildPayload: (_, user_id) => ({
        user_id,
        warning_type: "pip",
      }),
    },
    //12
    indiscipline: {
      title: "Warning – Indiscipline",
      inputs: [],
      buildPayload: (_, user_id) => ({
        user_id,
        warning_type: "indiscipline",
      }),
    },
    //13
    false_attendance: {
      title: "Show Cause – False Attendance",
      inputs: [{ id: "reason", label: "Reason", type: "textarea" }],
      buildPayload: (v, user_id) => ({
        user_id,
        showcause_type: "false_attendance",
        reason: v.reason,
      }),
    },
    //14
    false_bill_submission: {
      title: "Show Cause – False Bill Submission",
      inputs: [{ id: "reason", label: "Reason", type: "textarea" }],
      buildPayload: (v, user_id) => ({
        user_id,
        showcause_type: "false_bill_submission",
        reason: v.reason,
      }),
    },
    //15
    relinquish: {
      title: "Relinquishment From Services",
      inputs: [
        {
          id: "absent_since_date",
          label: "Absent Since Date",
          type: "date",
        },
      ],
      buildPayload: (v, user_id) => ({
        user_id,
        absent_since_date: v.absent_since_date,
      }),
    },
    //16
    designation_change: {
      title: "Designation Change",
      inputs: [
        {
          id: "designation_start_date",
          label: "New Designation Start Date",
          type: "date",
        },
      ],
      buildPayload: (v, user_id) => ({
        user_id,
        new_designation_start_date: v.designation_start_date,
      }),
    },
    //17
    roll_change: {
      title: "Role Change",
      inputs: [
        {
          id: "role_start_date",
          label: "New Role Start Date",
          type: "date",
        },
      ],
      buildPayload: (v, user_id) => ({
        user_id,
        new_role_start_date: v.role_start_date,
      }),
    },
  };

 const handleGenerateLetter = (item) => {
  const config = FORM_CONFIG[item.form_unique_key];

  if (item?.is_request_approved) return;
  if (item?.is_request_rejected) return;

  if (!config) {
    console.log("No config found for:", item.form_unique_key);
    return;
  }

  Swal.fire({
    title: `Generate ${item.form_name}?`,
    icon: "question",

    showConfirmButton: true,
    showDenyButton: true,
    showCancelButton: true,

    confirmButtonText: "Approve",
    denyButtonText: "Reject",
    cancelButtonText: "Close",

    confirmButtonColor: "#f26639",
    denyButtonColor: "#F69338",
    cancelButtonColor: "#aaa",
  }).then((res) => {
    if (res.isConfirmed) {
      openDynamicFormSwal(item.form_unique_key, item);
    }

    if (res.isDenied) {
      confirmReject(item);
    }

    // res.isDismissed → Close / outside click / ESC
  });
};


  const openDynamicFormSwal = (formKey, item) => {
    const config = FORM_CONFIG[formKey];
    const user_id = id;
    const doj = date_of_joining || "";
    const html = `
  <div class="swal-form-wrapper">
    ${config.inputs
      .map(
        (i) => `
        <div class="swal-form-row">
          <label for="${i.id}" class="swal-form-label">
            ${i.label}
          </label>

          ${
            i.type === "textarea"
              ? `<textarea 
                    id="${i.id}" 
                    class="swal2-textarea swal-form-input"
                ></textarea>`
              : `<input 
                    type="${i.type}" 
                    id="${i.id}" 
                    class="swal2-input swal-form-input"
                    min="${doj}"
                />`
          }
        </div>
      `,
      )
      .join("")}
  </div>
`;

    Swal.fire({
      title: config.title,
      html,
      showCancelButton: true,
      confirmButtonText: "Generate",
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      preConfirm: () => {
        const values = {};

        for (const input of config.inputs) {
          const val = document.getElementById(input.id)?.value;
          if (!val && !input.optional) {
            Swal.showValidationMessage("Please fill all required fields");
            return false;
          }
          values[input.id] = val;
        }

        if (config.validate) {
          const validation = config.validate(values);
          if (validation !== true) {
            Swal.showValidationMessage(validation);
            return false;
          }
        }

        return config.buildPayload(values, user_id);
      },
    }).then((res) => {
      if (res.isConfirmed) {
        const payload = {
          data: {
            form_unique_key: item.form_unique_key,
            is_request_approved: true,
            user_id: id,
          },
          EditId: item.id,
          params:{
            ...res.value
          }
        };
        dispatch(setFormReportsUpdatedAction(payload))

        console.log("✅ FINAL PAYLOAD:", res.value, payload);
      }
    });
  };
  const confirmReject = (item) => {
    Swal.fire({
      title: "Reject Request?",
      text: `Are you sure you want to reject ${item.form_name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#ef4d39",
      cancelButtonColor: "#9ca3af",
    }).then((res) => {
      if (!res.isConfirmed) return;

      const payload = {
        data: {
          form_unique_key: item.form_unique_key,
          is_request_rejected: true,
          user_id: id,
        },
        EditId: item.id,
      };
      dispatch(setFormReportsUpdatedAction(payload));

      console.log("❌ REJECT PAYLOAD:", payload);
      // later → dispatch(rejectAction(payload))
    });
  };
const truncateText = (text, max = 15) =>
  text?.length > max ? `${text.slice(0, max)}...` : text;
console.log(filteredExports ,"filteredExports");

  return (
    <>
      <div className="RoleCreatePopup  user_cards">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{ width: "80%" }}>
            <div className="asds">
              <div class="ModalHeader">
                <span className="UserCreate"> Exports </span>

                <div
                  className="CloseIcon"
                  onClick={(e) => {
                    handleClose(e);
                  }}
                >
                  <CloseOutlinedIcon />
                </div>
              </div>
            </div>

            <div
              className="Inner_PopUpss"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "12px 11px 6px 8px",
              }}
            >
{user_details && (
  <div className="user-card">
    <div className="user-card-header">
      <h3>
        {truncateText(user_details?.user_id?.first_name, 12)}
      </h3>
      <span className="emp-id">
        {truncateText(user_details?.client_id?.client_name, 18)}
      </span>
    </div>
  </div>
)}


    <div>
                <div className="Inner_export_tabs">
<div className="export-tabs">
  {tabs.map((tab) => (
    <button
      key={tab.key}
      className={`export-tab ${
        activeTab === tab.key ? "active" : ""
      }`}
      onClick={() => setActiveTab(tab.key)}
    >
      {tab.label}
    </button>
  ))}
</div>

              </div>
<div
                className="RoleButton"
style={{
                  display: "grid",
                  gap: "15px",
                  padding: "0px 15px 0px 15px",
                  marginBottom: "38px",
                  marginTop: "20px",
                  // alignItems: "center",
                  gridTemplateColumns:"1fr 1fr 1fr 1fr",
                  flexWrap: "wrap",
                  // justifyContent: "flex-start",
                  height: filteredExports != null && filteredExports?.length > 8 ? "556px":"",overflowY:"auto"
                }}
>
{filteredExports && filteredExports.length > 0 ? (
  filteredExports.map((item) => {
    let statusIcon, statusText, statusClass;
if (item.is_request_approved === true) {
  statusIcon = ApprovedIcon;
  statusText = "Approved";
  statusClass = "approved";

} else if (item.is_request_rejected === true) {
  statusIcon = RejectedIcon;
  statusText = "Rejected";
  statusClass = "rejected";

} else {
  // both false → Pending
  statusIcon = PendingIcon;
  statusText = "Pending";
  statusClass = "pending";
}


    return (
      <div key={item.id} className="export-card">
        <button
          className="btn sony_client_exports"
          disabled={item.is_request_rejected === true || item.is_request_approved === true}
          onClick={() => handleGenerateLetter(item)}
        >
          {item.form_name}
        </button>

        <div className="export-meta">
          <span className="created-date">
            {item.created_at
              ? new Date(item.created_at).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })
              : "--"}
          </span>

          <span className={`status ${statusClass}`}>
            <img src={statusIcon} alt={statusText} />
            {statusText}
          </span>
        </div>
      </div>
    );
  })
) : (
  <div className="empty-state">
    No records found
  </div>
)}

</div>
    </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestedPopup;
